{
    "WqUBffnHhBKKDMsimkKB9": {
        "key": "WqUBffnHhBKKDMsimkKB9",
        "position": {
            "x": 15,
            "y": 12,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "okiYpanputtFIg7IcljrR": {
        "key": "okiYpanputtFIg7IcljrR",
        "position": {
            "x": 15,
            "y": 13,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "nal03w110NB774yzGyqom": {
        "key": "nal03w110NB774yzGyqom",
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "WtWyLVedRZP0bGCHevigY": {
        "key": "WtWyLVedRZP0bGCHevigY",
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "pVYxTPJfwG_mK2twRtWy8": {
        "key": "pVYxTPJfwG_mK2twRtWy8",
        "position": {
            "x": 17,
            "y": 15,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "5dGMwftlmzGNql3mn2wcV": {
        "key": "5dGMwftlmzGNql3mn2wcV",
        "position": {
            "x": 16,
            "y": 15,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "tripjiwkn0XaD5l36SMOu": {
        "key": "tripjiwkn0XaD5l36SMOu",
        "position": {
            "x": 14,
            "y": 15,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "pv4yih6pRDfDWR879Bp1x": {
        "key": "pv4yih6pRDfDWR879Bp1x",
        "position": {
            "x": 14,
            "y": 16,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "E4BYjVZ8acMXmPCHyaO2Q": {
        "key": "E4BYjVZ8acMXmPCHyaO2Q",
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "qpXlYqJDlpqD_KGtdAnY8": {
        "key": "qpXlYqJDlpqD_KGtdAnY8",
        "position": {
            "x": 10,
            "y": 13,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "fP3LSA5al5eYoQH1GhQuq": {
        "key": "fP3LSA5al5eYoQH1GhQuq",
        "position": {
            "x": 10,
            "y": 12,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "QYd5jUUjSa2EiT3q0UpLV": {
        "key": "QYd5jUUjSa2EiT3q0UpLV",
        "position": {
            "x": 10,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    }
}